angular
  .module('resources.Settings', ['ngResource'])
  .factory('Settings', ['$resource', function ($resource) {
    return $resource('/api/settings', null, {
      get: {
        method: 'GET',
        url: '/api/settings/get',
        isArray: true
      },
      set: {
        method: 'POST',
        url: '/api/settings/set',
        isArray: true
      }
    });
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Settings.js